module.exports = __webpack_public_path__ + "img/gyermektamogatas-projekt-1.7b86fb14.jpg";